// extracted by mini-css-extract-plugin
export default {"wrapper":"spasibo_wrapper__Zo87i","card":"spasibo_card__yaIts","title":"spasibo_title__j8G7X","text":"spasibo_text__vJx8c"};